import { render, staticRenderFns } from "./myRecycleMore.vue?vue&type=template&id=745398c7&scoped=true"
import script from "./myRecycleMore.vue?vue&type=script&lang=js"
export * from "./myRecycleMore.vue?vue&type=script&lang=js"
import style0 from "./myRecycleMore.vue?vue&type=style&index=0&id=745398c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745398c7",
  null
  
)

export default component.exports